// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-22bd5398] .try-for-free-tooltip p{font-size:12px!important;line-height:18px!important}[data-v-22bd5398] .try-for-free-tooltip svg{top:-9px!important;left:38px!important;transform:rotate(90deg)}[data-v-22bd5398] .try-for-free-tooltip.tooltip{transform:scale(1)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
